import React from 'react';
import { IS_EUROPE } from '../config/region';
import { t } from '../i18n';
import LegalPage from './LegalPage';
import LegalDocument from './LegalDocument';

/* The two regions publish different documents, not translations of one: AI Novel is bound by a
   Russian ИП's terms, Plotex by a Kazakh TOO's. Only the europe one is generated from docs/. */
const RussianCookiesPage = () => (
  <LegalPage title="Согласие на Cookie">
    <p className="lp-subtitle">Богородское, редакция от 23.02.2026 г.</p>

    <p>Посетитель интернет-сайта https://ainovel.ru/ (далее – Сайт), используя Сайт, предоставляет настоящее согласие на использование файлов cookie (далее – Согласие) Лебедянскому Евгению Павловичу, реквизиты которого указаны в пункте 14 Согласия (далее – Оператор), на следующих условиях:</p>

    <p>1. На Сайте используются файлы cookie. Файл cookie представляет собой текстовый файл, который размещается на жестком диске посетителя Сайта сервером. Файлы cookie уникальны для каждого посетителя Сайта и могут быть прочитаны только сервером в домене, который их выдал.</p>
    <p>2. Задача файлов cookie – сообщить серверу, что посетитель Сайта вернулся на определенную страницу Сайта. Файлы cookie используются для повышения удобства пользования Сайтом. Файлы cookie не используются для запуска программ или передачи вирусов на компьютер посетителя Сайта.</p>
    <p>3. Все данные, собираемые о посетителе Сайта с помощью файлов cookie, обрабатываются в анонимной форме, исключающей возможность соотнесения их с каким-либо реальным посетителем Сайта. Использование Оператором файлов cookie не преследует цели идентифицировать конкретного посетителя Сайта.</p>
    <p>4. У посетителя Сайта есть возможность принимать или отклонять использование файлов cookie. Большинство браузеров автоматически принимают файлы cookie, но по желанию посетитель Сайта может изменить настройки своего браузера, чтобы отказаться от использования файлов cookie.</p>
    <p>5. В целях администрирования и обеспечения функционирования Сайта посетитель Сайта предоставляет Оператору Согласие на обработку персональных данных, осуществляемую Оператором посредством обработки файлов cookie. Согласие предоставляется посетителем Сайта в момент использования Сайта при условии разрешения в настройках браузера посетителя использования Cookies и JavaScript.</p>
    <p>6. Оператором, в частности, могут обрабатываться следующие персональные данные посетителя Сайта:</p>
    <ul>
      <li>тип браузера;</li>
      <li>операционная система;</li>
      <li>тип устройства;</li>
      <li>IP-адрес;</li>
      <li>настройки страны и языка и др.</li>
    </ul>
    <p>7. Обрабатываемые персональные данные не являются биометрическими и не относятся к специальным категориям.</p>
    <p>8. Основанием для обработки персональных данных является Согласие.</p>
    <p>9. В ходе обработки с персональными данными будут совершены следующие действия: сбор; запись; систематизация; накопление; хранение; уточнение (обновление, изменение); извлечение; использование; передача (предоставление, доступ); блокирование; удаление; уничтожение.</p>
    <p>10. Согласие предоставляется на обработку персональных данных с использованием средств автоматизации.</p>
    <p>11. Согласие на использование файлов cookie и согласие на обработку персональных данных действуют до момента отказа посетителя Сайта от использования технологий Cookies и JavaScript в настройках браузера посетителя.</p>
    <p>12. Предоставляя согласие на обработку персональных данных, посетитель Сайта понимает, что в случае отзыва согласия Оператор вправе продолжить обработку персональных данных без согласия посетителя при наличии оснований, указанных в пунктах 2 - 11 части 1 статьи 6 Федерального закона «О персональных данных» № 152-ФЗ от 27.07.2006 г.</p>
    <p>13. Предоставляя согласие на обработку персональных данных, посетитель Сайта гарантирует, что:</p>
    <ul>
      <li>он ознакомлен с Политикой в отношении обработки персональных данных Оператора, опубликованной на Сайте;</li>
      <li>ему известны и понятны юридические последствия отказа предоставить персональные данные, а также юридические последствия отказа предоставить согласие на обработку персональных данных в соответствии с действующим законодательством Российской Федерации.</li>
    </ul>

    <h2>14. Реквизиты Оператора</h2>
    <p>ИП Лебедянский Е. П.</p>
    <p>ИНН: 504232534204</p>
    <p>ОГРНИП: 326508100140604</p>
    <p>Адрес: Московская обл., Сергиево-Посадский район, РП Богородское</p>
    <p>Адрес электронной почты: ainovel@yandex.ru</p>
  </LegalPage>
);

const CookiesPage = () => {
  if (!IS_EUROPE) return <RussianCookiesPage />;
  return (
    <LegalPage
      title={t('Политика использования файлов cookie')}
      description={t('Какие файлы cookie использует платформа, для чего, на каком правовом основании и как ими управлять.')}
    >
      <LegalDocument id="cookies" />
    </LegalPage>
  );
};

export default CookiesPage;
